import {
    HTTP
} from '@/utilities/http-common';

export default {
    namespaced: true,
    state: {
        missed_product_count: 0
    },
    getters: {},
    mutations: {
        setMissedProductsCount(state, count) {
            state.missed_product_count = count;
        },
        getMissedProductCount(state) {
            return state.missed_product_count;
        }
    },
    actions: {
        setMissedProductsCount({
            commit
        }, count) {
            commit('setMissedProductsCount', count);
        },
        getMissedProductCount() {
            return HTTP.get('/kenya/missed_product_placement_count/');
        }
    },
}